export const SUPPORT_EMAIL = "support@coval.dev"

const SUPPORT_EMAIL_SUBJECT = "Coval support request"

/**
 * A `mailto:` link addressed to Coval support. A `body` prefills the draft and
 * brings a default subject with it; the user still sends it from their own
 * email app.
 */
export function buildSupportMailtoHref(body?: string): string {
  if (!body) {
    return `mailto:${SUPPORT_EMAIL}`
  }
  const query = new URLSearchParams({ subject: SUPPORT_EMAIL_SUBJECT, body })
  // mailto: decodes RFC 3986 percent-escapes, not form encoding, so a `+`
  // would reach the draft as a literal plus instead of a space.
  return `mailto:${SUPPORT_EMAIL}?${query.toString().replace(/\+/g, "%20")}`
}

/**
 * Hands a prefilled support email to the user's mail client. The browser gives
 * no signal whether a client picked it up, so callers must not claim it opened.
 */
export function openSupportEmailDraft(body: string): void {
  window.location.assign(buildSupportMailtoHref(body))
}
